// extracted by mini-css-extract-plugin
export default {"teacher":"LandingPage_teacher__y04L3","storeroom":"LandingPage_storeroom__dQsMg"};